///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum SelectedAreaInfoTabsEnum {
    ALL,
    LOCATIONS,
    LINKS
}
